import React, { useContext, useState, useEffect } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { UserContext } from './UserContext';
import './App.css';
import './SpardhaLayout.css';

const LAYOUT_TYPE_STORAGE_KEY = 'spardha_layout_type';

const SpardhaLayout = (props) => {
  const { userDetails, setUserDetails } = useContext(UserContext);

  // Use props.layoutType if provided, otherwise use state with localStorage
  const [selectedLayoutType, setSelectedLayoutType] = useState(() => {
    if (props.layoutType) return props.layoutType;
    const saved = localStorage.getItem(LAYOUT_TYPE_STORAGE_KEY);
    return saved || 'test';
  });

  const layoutType = props.layoutType || selectedLayoutType;

  const [formData, setFormData] = useState({
    name: '',
    place: '',
    photo: null,
    selectedModule: '',
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  // Save selected layout type to localStorage
  useEffect(() => {
    if (!props.layoutType) {
      localStorage.setItem(LAYOUT_TYPE_STORAGE_KEY, selectedLayoutType);
    }
  }, [selectedLayoutType, props.layoutType]);

  // Reset selected module when layout type changes
  useEffect(() => {
    setFormData(prev => ({ ...prev, selectedModule: '' }));
  }, [layoutType]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setFormData({ ...formData, photo: URL.createObjectURL(e.target.files[0]) });
    } else {
      setFormData({ ...formData, photo: null });
    }
  };

  const handleModuleChange = (e) => {
    setFormData({ ...formData, selectedModule: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setUserDetails({
      name: formData.name,
      place: formData.place,
      photo: formData.photo || userDetails.photo,
    });
    setIsSubmitted(true);
    if (formData.selectedModule) {
      navigate(formData.selectedModule);
    }
  };

  const testModules = [
    { value: '/pratyahara', label: 'M1 Pratyahara' },
    { value: '/Varnamalika', label: 'M2 Varnamalika Test' },
    { value: '/Shabdaadhikaaraha', label: 'M3 Shabdaadhikaaraha' },
  ];

  const demoModules = [
    { value: '/Shabdaadhikaaraha', label: 'M3 Shabdaadhikaaraha' },
    { value: '/Subantarupaani', label: 'M4 Subantarupaani' },
    { value: '/Krudantha', label: 'M5 Krudantha' },
    { value: '/GhiRupa', label: 'M5 GhiRupa' },
    { value: '/GhiRupa1', label: 'M6 GhiRupa1' },
  ];

  const modules = layoutType === 'test' ? testModules : demoModules;

  return (
    <>
      <div className="user-details">
        {userDetails.photo && <img src={userDetails.photo} alt="Uploaded" className="uploaded-photo" />}
        {userDetails.name && <span className="user-name">{userDetails.name}</span>}
      </div>
      <nav className="puzzle-nav">
        {!isSubmitted && (
          <>
            {/* Layout Type Toggle - only show for unified route */}
            {!props.layoutType && (
              <div className="spardha-type-toggle">
                <span className="toggle-label">प्रकारः:</span>
                <label className={`spardha-toggle-option ${layoutType === 'test' ? 'active' : ''}`}>
                  <input
                    type="radio"
                    name="layoutType"
                    value="test"
                    checked={selectedLayoutType === 'test'}
                    onChange={(e) => setSelectedLayoutType(e.target.value)}
                  />
                  <span>स्पर्धा (Test)</span>
                </label>
                <label className={`spardha-toggle-option ${layoutType === 'demo' ? 'active' : ''}`}>
                  <input
                    type="radio"
                    name="layoutType"
                    value="demo"
                    checked={selectedLayoutType === 'demo'}
                    onChange={(e) => setSelectedLayoutType(e.target.value)}
                  />
                  <span>Demo</span>
                </label>
              </div>
            )}

            <p className="form-intro">Enter your details</p>
            <form className="user-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <label>
                  <strong>Name:</strong>
                  <input type="text" placeholder="Enter your name" name="name" value={formData.name} onChange={handleInputChange} required />
                </label>
                <label>
                  <strong>Place:</strong>
                  <input type="text" placeholder="Enter your city" name="place" value={formData.place} onChange={handleInputChange} required />
                </label>
                <label>
                  <strong>Photo:</strong>
                  <input type="file" name="photo" onChange={handleFileChange} />
                </label>
              </div>
              <table align="center" bgcolor="lightyellow" border="2" bordercolor="crimson" cellPadding="3" cellSpacing="3" valign="middle" width="100%" className="puzzle-table">
                <tbody>
                  <tr>
                    <td className="puzzle-table-heading">
                      <strong>
                        {layoutType === 'test' ? 'Test Modules स्पर्धा प्रकाराः' : 'Demo'}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="module-row">
                {modules.map((module) => (
                  <label key={module.value}>
                    <input
                      type="radio"
                      name="selectedModule"
                      value={module.value}
                      checked={formData.selectedModule === module.value}
                      onChange={handleModuleChange}
                    />
                    <strong><Link to={module.value}>{module.label}</Link></strong>
                  </label>
                ))}
              </div>

              <button type="submit">Submit</button>
            </form>
          </>
        )}
      </nav>
      <Outlet />
    </>
  );
};

export default SpardhaLayout;
